import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import metadata from './PageFooterComponent.metadata.json5';
import pageFooterStyles from './PageFooterComponent.module.scss';
import appConfig from 'app-config';
import messages from './../PageHeaderComponent/PageHeaderComponent.messages';
import { TranslatorContext } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';


function PageFooterComponent() {
    const { env } = appConfig;     
    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext); 

    const getLogoSrc = useCallback(() => {
        const url = _.get(env, 'DEPLOYMENT_URL');        
        const logoUrl = (breakpoint === 'phone') ? `${url}/branding/Trillium_Primary_Logo_RGB.png` : `${url}/branding/Trillium_Secondary_Logo_Horizontal_RGB.png`      
       return logoUrl;
    }, [env]);

    const getNavLinks = () => {
        return(
            <div>
                <a
                 target="_self" href="/account-management/home" aria-label="home"
                  id="home">{translator(messages.home)}</a>
                <a
                 target="_self" href="/account-management/claims" aria-label="my claims"
                  id="myClaims" >{translator(messages.myClaims)}</a>
                <a
                 target="_self" href="/account-management/billing-summary" aria-label="my billing"
                  id="myBillings">{translator(messages.myBillings)}</a>
                <a
                 target="_self" href="/account-management/account-documents-summary" aria-label="my documents"
                  id="myDocuments" className={pageFooterStyles.footerLink}>{translator(messages.myDocuments)}</a>
                {/* <a
                 target="_self" href="/faq" aria-label="FAQ"
                  id="faq" className={pageFooterStyles.faq}>{translator(messages.faq)}</a> */}
            </div>
            )
    }

    const overrides = {
        footerLogoImage: {
            src: getLogoSrc()
        },
        customfooterNavBar:{
            content: getNavLinks()
        }

    };

    const resolvers = {
        resolveClassNameMap: pageFooterStyles
    };

    return renderContentFromMetadata(metadata.componentContent, overrides, resolvers);
}

PageFooterComponent.propTypes = {
    routes: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default withRouter(PageFooterComponent);
